export default __webpack_public_path__ + "af95f293462902e6cab2d605574b7dec.png";